module.exports = __webpack_public_path__ + "img/code.9cf5508b.gif";